<template>
  <div class="login-container">
    <div class="login-card">
      <h1 class="title">账号登录</h1>
      
      <form @submit.prevent="handleLogin">
        <div class="input-group">
          <label for="username">用户名</label>
          <input
            type="text"
            id="username"
            v-model="form.username"
            placeholder="请输入用户名"
            required
            :disabled="isLoading"
          />
        </div>
        
        <div class="input-group">
          <label for="password">密码</label>
          <input
            type="password"
            id="password"
            v-model="form.password"
            placeholder="请输入密码"
            required
            :disabled="isLoading"
          />
        </div>
        
        <div v-if="errorMsg" class="error-message">
          {{ errorMsg }}
        </div>
        
        <button 
          type="submit" 
          class="login-btn"
          :disabled="isLoading"
        >
          <span v-if="!isLoading">登 录</span>
          <span v-else>登录中...</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      isLoading: false,
      errorMsg: ''
    };
  },
  methods: {
    async handleLogin() {
      // 重置错误信息
      this.errorMsg = '';
      
      // 表单验证
      if (!this.form.username.trim() || !this.form.password) {
        this.errorMsg = '用户名和密码不能为空';
        return;
      }
      
      try {
        this.isLoading = true;
        
        // 发送登录请求
        const response = await axios.post('/film/selected/data/login', {
          userName: this.form.username,
          password: this.form.password
        }, {
          headers: { "Content-Type": 'application/json' }
        });
        
        // 处理响应
        if (response.data.code === 'msg00000') {
          // 登录成功处理
          console.log('登录成功', response.data);
          
          // 保存token到本地存储
          localStorage.setItem('token', response.data.data.token);

          // 使用Vue Router跳转到Films页面
          this.$router.push('/h5/films');
        } else {
          // 处理业务错误
          this.handleLoginError(response.data);
        }
      } catch (error) {
        // 处理网络错误
        this.handleNetworkError(error);
      } finally {
        this.isLoading = false;
      }
    },
    
    // 处理业务逻辑错误
    handleLoginError(responseData) {
      switch (responseData.code) {
        case 'msg40001':
          this.errorMsg = '用户名或密码错误';
          break;
        case 'msg40002':
          this.errorMsg = '账户已被锁定，请联系管理员';
          break;
        case 'msg40003':
          this.errorMsg = '账户未激活，请检查邮箱';
          break;
        default:
          this.errorMsg = responseData.message || '登录失败，请重试';
      }
    },
    
    // 处理网络错误
    handleNetworkError(error) {
      if (error.response) {
        // 服务器响应错误 (4xx, 5xx)
        if (error.response.status === 401) {
          this.errorMsg = '认证失败，请检查凭证';
        } else if (error.response.status === 403) {
          this.errorMsg = '无访问权限';
        } else {
          this.errorMsg = `服务器错误: ${error.response.status}`;
        }
      } else if (error.request) {
        // 请求已发出但无响应
        this.errorMsg = '网络连接失败，请检查网络';
      } else {
        // 其他错误
        this.errorMsg = '请求发送失败: ' + error.message;
      }
    }
  }
};
</script>

<style scoped>
/* 样式保持不变 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 16px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px 25px;
}

.title {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 30px;
  font-size: 24px;
}

.input-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #34495e;
  font-weight: 500;
}

input {
  width: 100%;
  padding: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

input:focus {
  border-color: #3498db;
  outline: none;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.login-btn {
  width: 100%;
  padding: 14px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-btn:active:not(:disabled) {
  background-color: #2980b9;
  transform: scale(0.98);
}

.login-btn:disabled {
  background-color: #a0c9e4;
  cursor: not-allowed;
  opacity: 0.8;
}

.error-message {
  color: #e74c3c;
  background-color: #fdeded;
  padding: 10px 15px;
  border-radius: 8px;
  margin: 15px 0;
  font-size: 14px;
  text-align: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 手机端适配 */
@media (max-width: 480px) {
  .login-card {
    padding: 25px 20px;
  }
  
  .title {
    font-size: 22px;
  }
  
  input {
    padding: 12px;
  }
  
  .login-btn {
    padding: 13px;
  }
}
</style>